<template>
  <div v-if="absolutetplprop">
    <div v-for="(aba, index) in myself.abas" :key="index" v-if="aba.nome == null">
      <v-card
        class="'pa-2 elevation-0 class_secao'"
        v-for="(secao, indexsec) in aba.secoes"
        :key="indexsec"
        v-if="secao.campos.length > 0"
      >
        <v-toolbar v-if="secao.nome != null">
          <v-toolbar-title>{{ T(secao.nome) }}</v-toolbar-title>
        </v-toolbar>
        <div
          :style="
            'position:relative; width:1000px;height:' +
              Math.ceil(secao.campos.length / 4) * 120 +
              'px;background-color:#ccc;'
          "
        >
          <template v-for="(campo, index) in secao.campos">
            <vue-resizable
              :left="positions[campo.cmp_coluna].l"
              :top="positions[campo.cmp_coluna].t"
              :width="positions[campo.cmp_coluna].w"
              :height="positions[campo.cmp_coluna].h"
              fitParent
              @mount="data => eHandlerDone(data, campo)"
              @resize:end="data => eHandler(data, campo)"
              @drag:end="data => eHandler(data, campo)"
              dragSelector="h4"
              :key="index"
              v-if="
                1 == 1 &&
                  displaying &&
                  positions[campo.cmp_coluna] &&
                  campo.m == null &&
                  (myself.metadata._skip == null ||
                    myself.metadata._skip[campo.cmp_coluna] !== true)
              "
            >
              <div
                class="content-put-default"
                :style="campo.cmp_cssstyle"
                :class="
                  'crudcampo-' +
                    myself.action +
                    ' text-xs-left pa-1 sm' +
                    campo.tpl +
                    ' ' +
                    (campo.cmp_cssclass || '') +
                    ' class_campo_' +
                    (campo.cmp_coluna || '')
                "
              >
                <h4 class="put-default-title">{{ campo.cmp_titulo }}</h4>
                <crudcampo
                  :crud="myself"
                  v-model="myself.form[campo.cmp_coluna]"
                  :campo="campo"
                  :row="myself.form"
                ></crudcampo>
              </div>
            </vue-resizable>
          </template>
        </div>
      </v-card>
    </div>

    <v-card v-if="absolutetplprop == true" class="table-tamplete-son no-shadow" style="width:200px">
      <v-card-title class="text-xs-center center-content-flex">
        <v-btn @click="$emit('closeProp')" class="no-shadow">{{T('Fechar')}}</v-btn>
      </v-card-title>

      <h2 class="title-templete-form">{{T('Templete')}}</h2>

      <v-card-text>
        <v-textarea style hide-details v-model="cssenter" box @keyup="mudado" rows="30"></v-textarea>
      </v-card-text>
      <span style="display:none;">{{ convertePraCSS() }}</span>
    </v-card>
  </div>
</template>

<script>


import _baseComponent from "@/framework/admin/tpl/tabelado.vue";

const crudcampo = global.reqClass.requirecmpmix("@/admin/listagem/crudcampo");
import VueResizable from "vue-resizable";
export default {
  extends: _baseComponent,
  components: { crudcampo, VueResizable },
  props: ["myself", "absolutetplprop"],
  data() {
    return {
      positions: {},
      cssenter: "",
      displaying: true,
    };
  },
  methods: {
    eHandler(data, campo) {
      if (!campo || !campo.cmp_coluna) return;

      this.positions[campo.cmp_coluna].l = data.left;
      this.positions[campo.cmp_coluna].t = data.top;
      this.positions[campo.cmp_coluna].w = data.width;
      this.positions[campo.cmp_coluna].h = data.height;

      this.$forceUpdate();
    },

    eHandlerDone() {
      let index = 0;
      for (let aba of this.myself.abas)
        for (let secao of aba.secoes) {
          for (let campo of secao.campos) {
            if (!campo || !campo.cmp_coluna) continue;
            if (this.positions[campo.cmp_coluna] == null)
              this.positions[campo.cmp_coluna] = {
                l: (index % 4) * 250,
                t: Math.floor(index / 4) * 120,
                w: 240,
                h: 120,
              };
            index++;
          }
        }
      this.$forceUpdate();
    },

    mudado(event) {
      try {
        let p1 = event.target.value
          .split("/*DATAJSON-" + this.myself.action + ":")[1]
          .split("*/")[0];
        console.log(p1);
        if (p1 != "") {
          this.positions = JSON.parse(p1);
          this.$forceUpdate();
          setTimeout((f) => {
            this.displaying = false;
            setTimeout((f) => {
              this.displaying = true;
            }, 100);
          }, 100);
        }
      } catch (err) {
        console.log(err);
      }
    },

    convertePraCSS() {
      let nh = Object.keys(this.positions).length;

      let maxw = 1000;
      let cols = [];

      for (let col in this.positions) {
        let o = this.positions[col];
        let el = `
        .flex.class_campo_${col}{
            position:absolute;
            left:${(100 * o.l) / maxw}%;
            top:${o.t}px;
            width:${(100 * o.w) / maxw}%;
            height:${o.h}px;
            max-width:100%!important;
        }
`;
        cols.push(el);
      }

      let r = `
.wrapper-module-${this.myself.lista.modulo.mod_tabela} {
   
    .v-form.form_tabelado_${this.myself.action} > div {
      min-height: ${Math.ceil(nh / 4) * 120}px;
    }
    .v-form.form_tabelado_${this.myself.action}{
    ${cols.join("\n")}
    }
  
}
        `;
      let ret =
        r +
        "\n\n\n/*DATAJSON-" +
        this.myself.action +
        ":" +
        JSON.stringify(this.positions) +
        "*/";
      this.cssenter = ret;

      this.$store.dispatch("setMemory", [
        "DEV_META_" +
          this.myself.lista.modulo.mod_tabela +
          "_" +
          this.myself.action,
        JSON.stringify(this.positions),
      ]);

      return ret;
    },
  },
  beforeMount() {
    if (Object.keys(this.positions).length == 0) {
      console.log("Tried", this.$store.state.memory);
      if (
        this.$store.state.memory &&
        this.$store.state.memory[
          "DEV_META_" +
            this.myself.lista.modulo.mod_tabela +
            "_" +
            this.myself.action
        ]
      ) {
        console.log(this.$store.state.memory);
        this.positions = JSON.parse(
          this.$store.state.memory[
            "DEV_META_" +
              this.myself.lista.modulo.mod_tabela +
              "_" +
              this.myself.action
          ]
        );
      }
    }
  },
  mounted() {
    this.eHandlerDone();
  },
};
</script>
